// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./retailersmodal.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

// event handler
var nunt = require("lib/nunt");
var dropdown = require("../dropdown/dropdown");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).retailers;
var parsing = require('parsing').retailersmodal;
var toggle_retailer_form_parts = require('../../scripts/modals').toggle_retailer_form_parts;

var dataSource = "";
var moduleData = false;

function parse(text, next) {
    strip(require('raw!./retailersmodal.html'), function(outputHtml) {
        // if the text after ":" isnt pc,van,smart or truck it is considered to be one or many id
        var match = parsing.parse(text);

        var options;

        if (match) {
            var that = this;

            var requireData = "dealers";

            if (match[5]) {
                requireData += "/byid/" + match[5];
            }
            else if (match[1]) {
                requireData += "/" + match[1];
            }

            getData(requireData, function (jsonString) {
                // check if the datasource is to be overridden
                if (that.dataSource && that.dataSource != "") {
                    jsonString = that.dataSource;
                }

                try {
                    if (typeof jsonString == "object") {
                        options = jsonString;
                    }
                    else {
                        options = JSON.parse(jsonString);
                    }
                }
                catch (e) {
                    options = false;
                }

                moduleData = options;

                var insertOptions = "";
                if (options) {
                    var array = [];

                    for (var i = 0; i < options.length; i++) {
                        var option = options[i];
                        var label = (option.label) ? option.label : option.city + ': ' + option.name;
                        var value = (option.value) ? option.value : option.outletcodeMb;

                        array[i] = '<li data-zipcode="' + option.zipcode.toLowerCase().replace(/ /g,'') + '" data-city="' + option.city.toLowerCase() + '" data-value="' + value + '" data-label="' + label + '" ><a id="' + value + '" class="retailer-link" href="#"><b>' + label + '</b></a></li>';
                    }

                    insertOptions = array.join("");
                }

                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var domObj = container.firstChild;

                outputHtml = outputHtml.replace("{{retailers.retailerlist}}", insertOptions);

                if (match[6] == "*") {
                    container.innerHTML = outputHtml;
                    domObj = container.firstChild;

                    // add a "required" class to the parent node
                    domObj.setAttribute("class", domObj.getAttribute("class") + " required");
                    domObj.setAttribute("data-required", "true");

                    outputHtml = container.innerHTML;
                }

                text = text.replace(match[0], outputHtml);
                next(text);
            });
        }
        else {
            next(text);
        }
    });
};

function validate(context, err) {
    var value = get(context);
    var required = context.getAttribute("data-required") == "true";
    var input = context.querySelector("#choose-retailer");

    var currentClasses = input.getAttribute("class") || "";
    currentClasses = currentClasses.replace(/(|\s)valid(|\s)/g, "").replace(/(|\s)error(|\s)/g, "");

    var messagelabel = context.querySelector("#txt_retailers-error");
    messagelabel.innerHTML = "";

    return validation.validate(value, required)
        .then(function(validationResult) {

            validationResult = !err ? validationResult : err;

            if (!validationResult) {
                validationResult = { valid: false };
            }

            if (!validationResult.valid) {
                input.setAttribute("class", currentClasses + " error");
                var message = document.createTextNode(context.getAttribute("data-msg-required"));
                messagelabel.appendChild(message);
                messagelabel.setAttribute("class", " error");
            }
            else {
                input.setAttribute("class", currentClasses + " valid");
                var message = document.createTextNode(context.getAttribute("data-msg-valid"));
                messagelabel.appendChild(message);
                messagelabel.setAttribute("class", " valid");
            }

            return validationResult.valid;
        });
}

function init(formRoot, meta, next) {
    function showDomElement(elem) {
        elem.setAttribute('class', (elem.getAttribute('class') || '').replace(/(|\s)hidden(|\s)/g, ''));
    }

    function hideDomElement(elem) {
        elem.setAttribute('class', (elem.getAttribute('class') || '') + ' hidden');
    }

    function maybeToggleFormParts(hasResult) {
        if (typeof toggle_retailer_form_parts != 'undefined') {
            toggle_retailer_form_parts();

            if (!hasResult) {
                showDomElement(retailerEmptyResult);
            } else if ( retailerEmptyResult.getAttribute('class').indexOf('hidden') == -1 ) {
                hideDomElement(retailerEmptyResult);
            }

                // hideDomElement(retailerEmptyResult);
            retailerInstruction.setAttribute('class', retailerInstruction.getAttribute('class') + ' hidden');
        }

    }

    var context = formRoot.querySelector('[data-module="retailersmodal"]');

    if (context) {

        var retailerFilter = context.querySelector('#retailer-filter');
        var sendPos = context.querySelector('#send-position');
        var listItems = context.querySelectorAll('.retailer-list li');
        var back = context.querySelector('#mbgf-modal-back');
        var showAll = context.querySelector('.retailers-show-all');
        var field = context.querySelector('#retailer-field');
        var toggleButton = context.querySelector('#choose-retailer');
        var close = context.querySelector('.mbgf-modal-header .close');
        var retailerInstruction = context.querySelector('.mbgf-modal-body .retailer-instruction');
        var retailerEmptyResult = context.querySelector('.mbgf-modal-body .retailers-emptyresult');

        retailerFilter.addEventListener('keypress', function(e) {
            if( e.keyCode == 13 ) {
                e.preventDefault();
                e.stopPropagation();
                sendPos.dispatchEvent(new Event('click'));
                return false;
            }
        });
        showAll.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            for (var i = 0, ii = listItems.length; i < ii; i++) {
                var retailer = listItems[i];
                showDomElement(retailer);
            }
            hideDomElement(retailerEmptyResult);
            retailerInstruction.setAttribute('class', retailerInstruction.getAttribute('class') + ' hidden');
        });

        sendPos.addEventListener('click', function(e) {
            var value = retailerFilter.value;
            var showCount = 0;

            var filterValues = function(query, original) {
                showCount = 0;

                // store original, city should only match against the whole query
                if( !original ) {
                    original = query;
                }

                for(var i = 0, ii = listItems.length; i < ii; i++) {
                    var classList = listItems[i].getAttribute('class') || '';
                    classList = classList.replace(/(|\s)hidden(|\s)/g, '');
                    var zipcode = listItems[i].getAttribute('data-zipcode');
                    var city = listItems[i].getAttribute('data-city');

                    var show = ( city.substring(0, original.length) == original.toLowerCase() || zipcode.substring(0, query.length) == query.toLowerCase() );

                    if( (!show || query.length == 0) && original.length != 0) {
                        classList = classList + ' hidden';
                    }
                    else {
                        showCount++;
                    }

                    listItems[i].setAttribute('class', classList);
                }

                if( showCount == 0 && query.length != 0 ) {
                    // empty try again with a shorter query
                    filterValues(query.substring(0, query.length - 1), original);
                }
            };


            function checkRetailers(value) {
                var valueLower = value ? value.toLowerCase() : value;

                var hasMatches = false;

                for (var i = 0, ii = listItems.length; i < ii; i++) {
                    var retailer = listItems[i];
                    var city = retailer.getAttribute('data-city');
                    var zipcode = retailer.getAttribute('data-zipcode');

                    var cityMatch = city.indexOf(valueLower) === 0;
                    var zipCodeMatch = zipcode.indexOf(valueLower) === 0;

                    if (cityMatch || zipCodeMatch) {
                        showDomElement(retailer);
                        hasMatches = true;
                    } else {
                        hideDomElement(retailer);
                        hasMatches = false || hasMatches;
                    }
                }
                return hasMatches;
            }


            function checkByZipCode() {

                getData('postnummerservice/search/' + retailerFilter.value, function (jsonString) {
                    console.log('result from postnummerservice');
                    console.log(jsonString);

                    var result;

                    try {
                        if (typeof jsonString == "object") {
                            result = jsonString;
                        }
                        else {
                            result = JSON.parse(jsonString);
                        }
                    } catch (e) {
                        result = false;
                    }

                    var filterValue = (result && result.result) ? result.result : retailerFilter.value;

                    filterValues(filterValue);

                    maybeToggleFormParts(showCount > 0);
                });
            }

            if (checkRetailers(value)) {
                console.log('found');
                maybeToggleFormParts(true);
            } else {
                console.log('not found');
                checkByZipCode();
            }
        });


        back.addEventListener('click', function(e) {
            console.log("back");
            console.log(toggle_retailer_form_parts);
            if( typeof toggle_retailer_form_parts != 'undefined' ) {
                toggle_retailer_form_parts();
                retailerInstruction.setAttribute('class', retailerInstruction.getAttribute('class').replace(/(|\s)hidden(|\s)/g, ''));
                if( retailerEmptyResult.getAttribute('class').indexOf('hidden') == -1 ) {
                    retailerEmptyResult.setAttribute('class', retailerEmptyResult.getAttribute('class') + ' hidden');
                }
            }
        });

        for(var i = 0, ii = listItems.length; i < ii; i++) {
            var listItem = listItems[i];

            listItem.addEventListener('click', function(e) {
                e.preventDefault();
                var value = this.getAttribute('data-value');
                var label = this.getAttribute('data-label');

                field.value = value;
                toggleButton.innerHTML = label;

                close.dispatchEvent(new Event('click', {bubbles: true}));
            });
        }
    }

    next(formRoot);
}

function get(context) {
    var value = context.querySelector('#retailer-field').value;
    return value;
}

function reset(context) {
    var input = context.querySelector('#retailer-field');
    input.value = '';
    var toggleButton = context.querySelector('#choose-retailer');
    toggleButton.innerHTML = toggleButton.getAttribute('data-default-label');
}

function data(value) {

    var res = moduleData;

    if( value && moduleData ) {
        for( var i = 0, ii = moduleData.length; i < ii; i++ ) {
            if( moduleData[i].value ) {
                if( value == moduleData[i].value ) {
                    res = moduleData[i];
                    break;
                }
            }
            else if( moduleData[i].outletcodeMb ) {
                if( value == moduleData[i].outletcodeMb ) {
                    res = moduleData[i];
                    break;
                }
            }
        }
    }

    return res;
}

module.exports = {
    parse: parse,
    validate: validate,
    dataSource: dataSource,
    init: init,
    get: get,
    data: data,
    dataKey: 'retailers',
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/retailersmodal/retailersmodal.js